import { useQuery } from '@tanstack/react-query';
import supabaseClient from '@/api/supabaseClient.ts';

type FamilyOnboardingRecord = {
  id?: string;
  email?: string;
  who_needs_care?: string | null;
  care_type?: string | null;
  frequency?: string | null;
  urgency?: string | null;
  start_type?: string | null;
  start_date?: string | null;
  location?: string | null;
  radius_km?: number | null;
  hourly_budget?: number | null;
  created_at?: string | null;
  updated_at?: string | null;
};

type GetFamilyOnboardingResponse = {
  data: unknown;
};

const useFamilyOnboarding = (email?: string | null, enabled = true) => {
  return useQuery<FamilyOnboardingRecord | null>({
    queryKey: ['family-onboarding', email],
    enabled: enabled && !!email,
    queryFn: async () => {
      if (!email) return null;

      const { data, error } = await supabaseClient.functions.invoke<GetFamilyOnboardingResponse>(
        'get_family_onboarding',
        {
          body: { email },
        }
      );

      if (error) {
        const message = error instanceof Error ? error.message : 'Error while fetching onboarding data.';
        throw new Error(message);
      }

      const response = (data as GetFamilyOnboardingResponse | null)?.data ?? null;
      // Handle possible double-wrapped shape { data: { ...actualData } }
      if (response && typeof response === 'object' && 'data' in (response as Record<string, unknown>)) {
        return (response as Record<string, unknown>)['data'] as FamilyOnboardingRecord;
      }

      return response as FamilyOnboardingRecord | null;
    },
  });
};

export type { FamilyOnboardingRecord };

export default useFamilyOnboarding;

